import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Icon from '@material-ui/core/Icon';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

import MoneyFormat from './format/MoneyFormat.js';

import firebase from 'firebase/app';

import moment from 'moment';
import _ from 'lodash';
import { Chip } from '@material-ui/core';

require("firebase/firestore");
require("moment-duration-format");

const styles = theme => ({
  root: {
    width: '100%',
  },
  backButton: {
    marginRight: theme.spacing(),
  },
  instructions: {
    marginTop: theme.spacing(),
    marginBottom: theme.spacing(),
  },
  textField: {
    width: 170,
  },
  textFieldBig: {
    width: 340 + theme.spacing(2),
  },
  marginRight: {
    marginRight: theme.spacing(2),
  },
  marginLeft: {
    marginLeft: theme.spacing(2),
  }
});

function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

function getSteps() {
  return ['Desk Check-Out', 'Finish Payment', 'Transaction Details'];
}
function getStepsAction() {
  return ['Check-Out', 'Finish', 'update'];
}

class CheckOutDialog extends Component {
  state = {
    open: this.props.open,
    processing: false,
    activeStep: 0,

    visitCount: 0,
    lastVisit: null,
    deskTransaction: null,

    checkOutTime: null,
    selectedPass: '',
    suggestedAmount: '',
    suggestedAmountDesc: '',
    paymentAmount: '',
    paymentMethod: '',
    extraService: '',
    extraServiceFee: '',
    remark: '',
    staffRemark: '',
  };

  queryUser = (deskTransaction) => {
    return this.queryUserVisitInfo(deskTransaction.userId);
    // return Promise.all([
    //   this.queryUserLastVisit(deskTransaction.userId),
    // this.queryUserVisitCount(deskTransaction.userId)
    // ]);
  }

  queryUserVisitInfo = userId => {
    return firebase.firestore()
      .collection('users')
      .doc(userId)
      .get()
      .then(doc => {
        let user = doc.data();

        this.setState({
          visitCount: user.visitCount || 0,
          lastVisit: (user.lastVisitedDateTime && user.lastVisitedDateTime.toDate()) || null,
        });
        return Promise.resolve();
      });
  }

  // queryUserVisitCount = (userId) => {
  //   return firebase.firestore()
  //     .collection('deskTransaction')
  //     .where("userId", "==", userId)
  //     .where('checkInTime', '<', moment().set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0}).toDate())
  //     .orderBy("checkInTime", "desc")
  //     .get()
  //     .then(querySnapshot => {
  //       this.setState({ visitCount: querySnapshot.size });
  //       return Promise.resolve();
  //     });
  // }

  // queryUserLastVisit = (userId) => {
  //   return firebase.firestore()
  //     .collection('deskTransaction')
  //     .where("userId", "==", userId)
  //     .where('checkInTime', '<', moment().set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0}).toDate())
  //     .orderBy("checkInTime", "desc")
  //     .limit(1)
  //     .get()
  //     .then(querySnapshot => {
  //       querySnapshot.forEach(doc => {
  //         this.setState({ lastVisit: doc.data().checkInTime.toDate() });
  //       });
  //       return Promise.resolve();
  //     });
  // }

  queryDeskTransaction = () => {
    return firebase.firestore()
      .collection('deskTransaction')
      .doc(this.state.deskTransaction.id)
      .get()
      .then(doc => {
        if (doc.exists) {
          let deskTransaction = doc.data();
          deskTransaction.id = doc.id;
          this.applyTransaction(deskTransaction);
        }
        return Promise.resolve();
      });
  }

  submitCheckOut = () => {
    if (this.state.checkOutTime && this.state.deskTransaction) {
      this.startProcessing();
      firebase.firestore()
        .collection('deskTransaction')
        .doc(this.state.deskTransaction.id)
        .update({
          checkOutTime: this.state.checkOutTime,
          extraService: this.state.extraService,
          extraServiceFee: this.state.extraServiceFee,
        })
        .then(this.queryDeskTransaction)
        .then(this.stopProcessing);
    }
  }

  rollbackCheckOut = () => {
    if (this.state.deskTransaction && this.state.deskTransaction.checkOutTime) {
      this.startProcessing();
      firebase.firestore()
        .collection('deskTransaction')
        .doc(this.state.deskTransaction.id)
        .update({ checkOutTime: firebase.firestore.FieldValue.delete(), })
        .then(this.queryDeskTransaction)
        .then(this.stopProcessing);
    }
  }

  submitPayment = () => {
    if (this.state.deskTransaction && isNumeric(this.state.paymentAmount)) {
      this.startProcessing();

      this.submitPassTransaction()
        .then(passTransactionId => {
          let promise = this.submitDeskTransaction(passTransactionId);
          if (passTransactionId) {
            return promise.then(() => { return this.submitPassAmendment() });
          }
          return promise;
        })
        .then(this.queryDeskTransaction) // Refresh
        .then(this.stopProcessing);
    }
  }

  submitDeskTransaction = (passTransactionId) => {
    return firebase.firestore()
      .collection('deskTransaction')
      .doc(this.state.deskTransaction.id)
      .update({
        suggestedAmount: this.state.suggestedAmount,
        paymentAmount: this.state.paymentAmount,
        paymentMethod: (this.hasPaymentAmount() && this.state.paymentMethod) || firebase.firestore.FieldValue.delete(),
        extraService: this.state.extraService,
        extraServiceFee: this.state.extraServiceFee,
        passUsed: this.state.selectedPass,
        passTransactionId: passTransactionId,
        remark: this.state.remark || firebase.firestore.FieldValue.delete(),
        staffRemark: this.state.staffRemark || firebase.firestore.FieldValue.delete(),
      });
  }

  submitPassTransaction = () => {
    if (this.state.selectedPass) {
      let pass = this.props.passes.find(pass => pass.id === this.state.selectedPass);

      let adjustment = 0;
      switch (pass.unit) {
        case 'day':
        case 'time':
          adjustment = -1;
          break;
        case 'month':
          break;
        default:
      }

      return firebase.firestore()
        .collection('passTransaction')
        .add({
          userId: this.state.deskTransaction.userId,
          passId: this.state.selectedPass,
          adjustment: adjustment,
          transactionDate: new Date(),
          deskTransactionId: this.state.deskTransaction.id,
          branch: this.props.branchId,
        })
        .then(doc => { return doc.id });
    } else {
      return Promise.resolve(null);
    }
  }

  submitPassAmendment = () => {
    let userPassRef = firebase.firestore().collection('userPasses');
    let passRecord = this.props.userPassRecord && this.props.userPassRecord[this.state.selectedPass];
    let pass = this.props.passes.find(pass => pass.id === this.state.selectedPass);
    switch (pass.unit) {
      case 'day':
      case 'time':
        if (passRecord && passRecord.remaining > 0) {
          return userPassRef.doc(passRecord.id).update({ remaining: passRecord.remaining - 1 });
        } else {
          return Promise.reject(new Error('zero remaining'));
        }
      case 'month':
        return Promise.resolve();
      default:
        return Promise.resolve();
    }
  }

  submitExtraServiceUpdate = () => {
    if (!this.state.deskTransaction ||
      this.getStep(this.state.deskTransaction) !== 0) {
      return;
    }

    let oldExtraService = this.state.deskTransaction.extraService || '';
    let newExtraService = this.state.extraService;
    let oldExtraServiceFee = this.state.deskTransaction.extraServiceFee || '';
    let newExtraServiceFee = this.state.extraServiceFee;

    if (oldExtraService !== newExtraService ||
      oldExtraServiceFee !== newExtraServiceFee) {
      firebase.firestore()
        .collection('deskTransaction')
        .doc(this.state.deskTransaction.id)
        .update({
          extraService: newExtraService,
          extraServiceFee: newExtraServiceFee,
        });
    }
  }

  submitRemarkUpdate = () => {
    this.startProcessing();
    firebase.firestore()
      .collection('deskTransaction')
      .doc(this.state.deskTransaction.id)
      .update({ remark: this.state.remark, })
      .then(this.stopProcessing);
  }

  getPassName = () => {
    let pass = this.props.passes.find(pass => { return pass.id === this.state.deskTransaction.passUsed });
    return ((pass && pass.name) || '');
  }

  getStep = (deskTransaction) => {
    if (deskTransaction.checkOutTime) {
      if (isNumeric(deskTransaction.paymentAmount)) {
        return 2;
      }
      return 1;
    }
    return 0;
  }

  onPassSelected = (selectedPass) => {
    var step = this.state.activeStep;
    var deskTransaction = this.state.deskTransaction;
    var suggestedAmount = '';
    var suggestedAmountDesc = '';
    var paymentAmount = '';

    switch (step) {
      case 1:
        var priceResult = this.calculateSuggestedPrice(deskTransaction.checkInTime, deskTransaction.checkOutTime, selectedPass);
        suggestedAmount = priceResult.value;
        suggestedAmountDesc = priceResult.desc;
        paymentAmount = suggestedAmount;
        break;
      case 2:
        suggestedAmount = deskTransaction.suggestedAmount;
        paymentAmount = deskTransaction.paymentAmount;
        break;
      default:
    }

    this.setState({
      selectedPass: selectedPass,
      suggestedAmount: suggestedAmount,
      suggestedAmountDesc: suggestedAmountDesc,
      paymentAmount: paymentAmount,
    });
  }

  applyTransaction = (deskTransaction) => {
    var step = this.getStep(deskTransaction);
    var suggestedAmount = '';
    var suggestedAmountDesc = '';
    var paymentAmount = '';

    switch (step) {
      case 1:
        var priceResult = this.calculateSuggestedPrice(deskTransaction.checkInTime, deskTransaction.checkOutTime, this.state.selectedPass);
        suggestedAmount = priceResult.value;
        suggestedAmountDesc = priceResult.desc;
        paymentAmount = suggestedAmount;
        break;
      case 2:
        suggestedAmount = deskTransaction.suggestedAmount;
        paymentAmount = deskTransaction.paymentAmount;
        break;
      default:
    }

    this.setState({
      deskTransaction: deskTransaction,

      activeStep: step,

      suggestedAmount: suggestedAmount,
      suggestedAmountDesc: suggestedAmountDesc,
      paymentAmount: paymentAmount,
      paymentMethod: deskTransaction.paymentMethod || "",
      extraService: deskTransaction.extraService || "",
      extraServiceFee: deskTransaction.extraService ? deskTransaction.extraServiceFee || 0 : "",
      remark: deskTransaction.remark,
      staffRemark: deskTransaction.staffRemark,
    });
  }

  calculateSuggestedPrice = (checkInTime, checkOutTime, selectedPass) => {
    var pass = this.props.passes.find(element => { return element.id === selectedPass });
    var durationOffset = 0;
    if (pass) {
      switch (pass.unit) {
        case 'time':
          durationOffset = pass.durationOffset || 0;
          break;
        case 'day':
        case 'month':
          return { "desc": "excluded by Pass", "value": 0, };
        default:
      }
    }

    if (checkInTime && checkOutTime) {
      var priceRule = _.chain(this.props.priceRule)
        .filter(rule => rule.active)
        .sort((a, b) => a.order - b.order)
        .value();
      var unitPriceRule = priceRule.find(rule => rule.unit);
      priceRule = priceRule.filter(rule => !rule.unit);

      if (unitPriceRule) {
        var weekday = moment(checkInTime.toDate()).isoWeekday() <= 5 ? 'weekday' : 'weekend';
        var duration = Math.max((moment(checkOutTime.toDate()).diff(checkInTime.toDate()) / 1000) - durationOffset, 0);
        duration -= duration > unitPriceRule.buffer ? unitPriceRule.buffer : 0;

        var totalPrice = 0;
        var activeRule = null;
        var priceStep = [];

        for (var i = 1; i <= Math.ceil(duration / unitPriceRule.unit); i++) {
          var nextDuration = unitPriceRule.unit * i;
          var nextPrice = totalPrice;

          if (!activeRule || !this.checkPriceRule(activeRule, nextDuration)) { // hold the price until active rule was exceeded
            nextPrice += unitPriceRule[weekday];
            activeRule = null;
          }

          // var hitRule = priceRule.find(rule => {
          //   return (!activeRule || rule.order > activeRule.order) && rule[weekday] < nextPrice && this.checkPriceRule(rule, nextDuration)
          // });
          let hitRule;
          for (let rule of priceRule) {
            if ((!activeRule || (rule.order > activeRule.order)) && (rule[weekday] < nextPrice) && this.checkPriceRule(rule, nextDuration)) {
              hitRule = rule;
              break;
            }
          }
          if (hitRule) {
            totalPrice = hitRule[weekday];
            activeRule = hitRule;
            priceStep = [totalPrice + "(#" + hitRule.order + ")"];
          } else {
            if (nextPrice - totalPrice > 0) {
              priceStep.push(nextPrice - totalPrice);
            }
            totalPrice = nextPrice;
          }
        }

        return { "desc": priceStep.join(" + "), "value": totalPrice, };
      }
    }
    return { "value": 0 };
  }

  checkPriceRule = (rule, duration) => {
    if (rule.conditions) {
      return rule.conditions.every(condition => {
        if (condition.duration && condition.operator) { // duration
          var target = condition.duration/* + rule.buffer*/;
          switch (condition.operator) {
            case "l":
              return duration < target;
            case "le":
              return duration <= target;
            case "e":
              return duration === target;
            case "ge":
              return duration >= target;
            case "g":
              return duration > target;
            default:
              return false;
          }
        } else if (condition.firstCome) { // first come
          return this.state.visitCount === 1;
        }
        return false;
      });
    }
    return false;
  }

  hasDeskFee = () => {
    return this.state.paymentAmount;
  }

  hasExtraServiceFee = () => {
    return this.state.extraService && this.state.extraServiceFee;
  }

  hasPaymentAmount = () => {
    return (this.state.paymentAmount || 0) + ((this.state.extraService && this.state.extraServiceFee) || 0) !== 0
  }

  selectAll = (event) => event.target.select();

  handleActionButton = () => {
    switch (this.state.activeStep) {
      case 0:
        this.submitCheckOut();
        break;
      case 1:
        this.submitPayment();
        break
      case 2:
        this.submitRemarkUpdate();
        break;
      default:
    }
  }

  handleBackButton = () => {
    switch (this.state.activeStep) {
      case 1:
        this.rollbackCheckOut();
        break;
      default:
    }
  }

  handleRequestClose = () => {
    this.submitExtraServiceUpdate();
    this.setState({ open: false });
    this.props.onRequestClose();
  }

  startProcessing = () => {
    this.setState({ processing: true });
  }

  stopProcessing = () => {
    this.setState({ processing: false });
    return Promise.resolve();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.open !== this.state.open) {
      if (nextProps.open) {
        this.setState({
          processing: false,
          activeStep: 0,

          visitCount: 0,
          lastVisit: null,
          deskTransaction: null,

          checkOutTime: new Date(),
          selectedPass: '',
          suggestedAmount: '',
          suggestedAmountDesc: '',
          paymentAmount: '',
          paymentMethod: '',
          extraService: '',
          extraServiceFee: '',
          remark: '',
          staffRemark: '',
        });

        this.queryUser(nextProps.deskTransaction)
          .then(() => this.applyTransaction(nextProps.deskTransaction));
      }
      this.setState({ open: nextProps.open, });
    }
  }

  render() {
    const { classes, branchId } = this.props;
    const steps = getSteps();
    const stepsAction = getStepsAction();
    const { activeStep } = this.state;

    let stepContent = null;
    let stepAction = null;
    let backAction = null;

    if (this.state.deskTransaction) {
      stepContent = (
        <div>
          {/* Desk Service */}
          <Typography variant="h6" color="textSecondary">Desk Service</Typography>
          <div style={{ display: 'flex', flexWrap: 'wrap' }}>
            <TextField
              className={`${classes.textField} ${classes.marginRight}`}
              disabled
              label="Check-In Time"
              value={this.state.deskTransaction && moment(this.state.deskTransaction.checkInTime.toDate()).format('LTS')}
              margin="normal" />
            <TextField
              className={`${classes.textField} ${classes.marginRight}`}
              InputLabelProps={{ shrink: true, }}
              inputProps={{ step: 1, }}
              margin="normal"
              label="Check-Out Time"
              type="time"
              disabled={this.state.activeStep >= 1}
              defaultValue={
                this.state.activeStep === 0 ?
                  moment(this.state.checkOutTime).format('HH:mm:ss') :
                  moment(this.state.deskTransaction.checkOutTime.toDate()).format('HH:mm:ss')
              }
              onChange={event => {
                this.setState({ checkOutTime: event.target.value ? moment(event.target.value, 'HH:mm:ss').toDate() : null })
              }} />
            <TextField
              className={`${classes.textField}`}
              disabled
              label="Duration"
              value={moment.duration(moment(this.state.activeStep === 0 ? this.state.checkOutTime : this.state.deskTransaction.checkOutTime.toDate()).diff(this.state.deskTransaction.checkInTime.toDate())).format("h:mm:ss", { trim: false })}
              margin="normal" />
          </div>
          <br />
          {/* Extra Service */}
          <Typography variant="h6" color="textSecondary">Extra Service</Typography>
          <div style={{ display: 'flex', flexWrap: 'wrap' }}>
            {/* Extra Service */}
            <FormControl
              margin="normal"
              className={`${classes.textField} ${classes.marginRight}`}
              disabled={this.state.activeStep === 2}>
              <InputLabel shrink>Type</InputLabel>
              <Select
                displayEmpty
                value={this.state.extraService}
                onChange={event => this.setState({
                  extraService: event.target.value,
                  extraServiceFee: event.target.value ? 0 : '',
                })}
              >
                <MenuItem value="">None</MenuItem>
                <MenuItem value="printing">Printing</MenuItem>
                <MenuItem value="room_booking">Room booking</MenuItem>
                <MenuItem value="venue_rental">Venue rental</MenuItem>
                <MenuItem value="workshop">Workshop</MenuItem>
                <MenuItem value="others">Others</MenuItem>
              </Select>
            </FormControl>
            {/* Extra Service Fee */}
            <FormControl
              margin="normal"
              className={`${classes.textField}`}>
              <InputLabel shrink>Fee</InputLabel>
              <Input
                disabled={
                  this.state.activeStep === 2 ||
                  !this.state.extraService
                }
                value={this.state.extraServiceFee}
                inputComponent={MoneyFormat}
                onFocus={event => this.selectAll(event)}
                onChange={event => {
                  let newState = {};

                  let extraServiceFee = parseInt(event.target.value.replace(/\D/g, ''), 10);
                  newState.extraServiceFee = isNaN(extraServiceFee) ? '' : extraServiceFee;

                  if (!extraServiceFee && !this.hasDeskFee()) {
                    newState.paymentMethod = '';
                  }

                  this.setState(newState);
                }}
              />
            </FormControl>
          </div>

          {this.state.activeStep >= 1 ?
            <div>
              <br />
              {/* Payment */}
              <Typography variant="h6" color="textSecondary">Payment</Typography>

              {/* Using Pass */}
              {this.state.activeStep === 1 ?
                <FormControl
                  margin="normal"
                  className={`${classes.textFieldBig}`}>
                  <InputLabel shrink>Using Pass</InputLabel>
                  <Select
                    displayEmpty
                    value={this.state.selectedPass}
                    onChange={event => this.onPassSelected(event.target.value)} >
                    <MenuItem value=''>None</MenuItem>
                    {
                      this.props.passes
                        .filter(pass => pass.active && pass.branch === branchId)
                        .map((pass, index) => {
                          const passRecord = this.props.userPassRecord && this.props.userPassRecord[pass.id];

                          var isAvailable = true;
                          if (pass.weekdayOnly && moment(this.state.deskTransaction.checkInTime.toDate()).isoWeekday() > 5) {
                            isAvailable = false;
                          }
                          if (pass.weekendOnly && moment(this.state.deskTransaction.checkInTime.toDate()).isoWeekday() <= 5) {
                            isAvailable = false;
                          }
                          if (pass.isNigthOnly && moment(this.state.deskTransaction.checkInTime.toDate()).isBefore(moment().hour(18).minute(30))) {
                            isAvailable = false;
                          }

                          var label = null;
                          switch (pass.unit) {
                            case 'time':
                            case 'day':
                              var remaining = (passRecord && passRecord.remaining) || 0;
                              if (remaining > 0) {
                                label = remaining + ' ' + pass.unit + (remaining > 1 ? 's' : '');
                              } else {
                                isAvailable = false;
                              }

                              if (passRecord && passRecord.expiryDate) {
                                if (moment(passRecord.expiryDate.toDate()).isAfter(moment())) {
                                  label += ' ~ ' + moment(passRecord.expiryDate.toDate()).format('ll');
                                } else {
                                  isAvailable = false;
                                }
                              }
                              break;
                            case 'month':
                              if (passRecord && passRecord.expiryDate && moment(passRecord.expiryDate.toDate()).isAfter(moment())) {
                                label = '~ ' + moment(passRecord.expiryDate.toDate()).format('ll');
                              } else {
                                isAvailable = false;
                              }
                              break;
                            default:
                          }

                          return (
                            <MenuItem
                              key={index}
                              value={pass.id}
                              disabled={!isAvailable}
                            >
                              <div>
                                {pass.name}
                                {' '}
                                <Chip size='small' label={pass.branch} />
                                {' · '}
                                {isAvailable ? label : '-'}
                              </div>
                            </MenuItem>
                          );
                        })
                    }
                  </Select>
                </FormControl>
                :
                this.state.deskTransaction.passUsed ?
                  <TextField
                    disabled
                    label="Pass Used"
                    value={this.getPassName()}
                    margin="normal" />
                  :
                  null
              }

              <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                {/* Suggested Amount */}
                <FormControl
                  margin="normal"
                  className={`${classes.textField} ${classes.marginRight}`}>
                  <InputLabel shrink>Suggested Amount</InputLabel>
                  <Input
                    disabled
                    value={this.state.suggestedAmount}
                    inputComponent={MoneyFormat}
                  />
                  {this.state.suggestedAmountDesc !== "" ? <FormHelperText>{this.state.suggestedAmountDesc}</FormHelperText> : null}
                </FormControl>
                {/* Autual Amount */}
                <FormControl
                  required
                  margin="normal"
                  className={`${classes.textField} ${classes.marginRight}`}>
                  <InputLabel shrink>Actual Amount</InputLabel>
                  <Input
                    disabled={this.state.activeStep === 2}
                    value={this.state.paymentAmount}
                    inputComponent={MoneyFormat}
                    onFocus={event => this.selectAll(event)}
                    onChange={event => {
                      let newState = {};

                      let paymentAmount = parseInt(event.target.value.replace(/\D/g, ''), 10);
                      newState.paymentAmount = isNaN(paymentAmount) ? '' : paymentAmount;

                      if (!paymentAmount && !this.hasExtraServiceFee()) {
                        newState.paymentMethod = '';
                      }

                      this.setState(newState);
                    }}
                  />
                </FormControl>
              </div>

              <div style={{ marginTop: 8, display: 'flex', flexWrap: 'wrap' }}>
                {/* Payment Method */}
                <FormControl
                  required={this.hasPaymentAmount()}
                  margin="normal"
                  className={`${classes.textField} ${classes.marginRight}`}
                  disabled={this.state.activeStep === 2 || !this.hasPaymentAmount()}>
                  <InputLabel shrink>Payment Method</InputLabel>
                  <Select
                    value={this.state.paymentMethod}
                    onChange={event => this.setState({ paymentMethod: event.target.value })}
                  >
                    <MenuItem value="cash">Cash</MenuItem>
                    <MenuItem value="payme">PayMe</MenuItem>
                    <MenuItem value="bank_transfer">Bank Transfer</MenuItem>
                    <MenuItem value="octopus">Octopus</MenuItem>
                    <MenuItem value="visa">Visa</MenuItem>
                    <MenuItem value="master">Mastercard</MenuItem>
                    <MenuItem value="ae">American Express</MenuItem>
                    <MenuItem value="alipay">Alipay</MenuItem>
                    <MenuItem value="wechat_pay">WeChat Pay</MenuItem>
                  </Select>
                </FormControl>
                {/* Total Amount */}
                <FormControl
                  margin="normal"
                  className={`${classes.textField}`}>
                  <InputLabel shrink>Total Amount</InputLabel>
                  <Input
                    disabled
                    value={(this.state.paymentAmount || 0) + (this.state.extraServiceFee || 0)}
                    inputComponent={MoneyFormat}
                  />
                  <FormHelperText>${this.state.paymentAmount || 0} + ${this.state.extraServiceFee || 0}</FormHelperText>
                </FormControl>
              </div>

              <br />
              <Typography variant="h6" color="textSecondary">Others</Typography>

              {/* Who are you */}
              <TextField
                InputLabelProps={{ shrink: true, }}
                disabled={this.state.activeStep === 2}
                required
                fullWidth
                multiline
                label="Who are you?"
                margin="normal"
                value={this.state.staffRemark || ''}
                onChange={(event) => this.setState({ staffRemark: event.target.value })} />

              {/* Remark */}
              <TextField
                InputLabelProps={{ shrink: true, }}
                fullWidth
                multiline
                label="Remark"
                margin="normal"
                value={this.state.remark || ''}
                onChange={(event) => this.setState({ remark: event.target.value })} />
            </div>
            : null}

        </div>
      );
    }

    switch (this.state.deskTransaction && this.state.activeStep) {
      case 0:
        stepAction = (
          <Button
            disabled={
              this.state.processing ||
              !this.state.checkOutTime ||
              moment(this.state.checkOutTime).isBefore(this.state.deskTransaction.checkInTime.toDate())
            }
            onClick={this.handleActionButton}
            color="primary">
            {stepsAction[activeStep]}
            <Icon style={{ marginLeft: 8 }}>chevron_right</Icon>
          </Button>
        );
        break;
      case 1:
        backAction = (
          <Button
            disabled={this.state.processing}
            onClick={this.handleBackButton}>
            <Icon style={{ marginRight: 8 }}>chevron_left</Icon>
            BACK
          </Button>
        );
        stepAction = (
          <Button
            disabled={
              this.state.processing ||
              !isNumeric(this.state.paymentAmount) ||
              (this.hasPaymentAmount() && !this.state.paymentMethod) ||
              !this.state.staffRemark
            }
            onClick={this.handleActionButton}
            color="primary">
            {stepsAction[activeStep]}
            <Icon style={{ marginLeft: 8 }}>chevron_right</Icon>
          </Button>
        );
        break;
      case 2:
        stepAction = (
          <Button
            disabled={this.state.processing}
            onClick={this.handleActionButton}
            color="primary">
            {stepsAction[activeStep]}
            <Icon style={{ marginLeft: 8 }}>save</Icon>
          </Button>
        );
        break;
      default:
    }

    return (
      <Dialog
        onClose={this.handleRequestClose}
        open={this.state.open}>
        <DialogContent>
          <div>
            <Stepper activeStep={activeStep} alternativeLabel>
              {steps.map(label => {
                return (
                  <Step key={label}>
                    <StepLabel>{label}</StepLabel>
                  </Step>
                );
              })}
            </Stepper>

            {this.state.deskTransaction ?
              <div>
                {/* Customer */}
                <Typography variant="h6" color="textSecondary">Customer</Typography>
                <div style={{ display: 'flex', flexWrap: 'wrap', }}>
                  <TextField
                    InputLabelProps={{ shrink: true, }}
                    className={`${classes.textField} ${classes.marginRight}`}
                    disabled
                    label="Name"
                    value={(this.props.customer && this.props.customer.name) || ''}
                    margin="normal" />
                  <TextField
                    InputLabelProps={{ shrink: true, }}
                    className={`${classes.textField} ${classes.marginRight}`}
                    disabled
                    label="Phone"
                    value={(this.props.customer && this.props.customer.phone) || ''}
                    margin="normal" />
                  <TextField
                    InputLabelProps={{ shrink: true, }}
                    className={`${classes.textField}`}
                    disabled
                    label="Email"
                    value={(this.props.customer && this.props.customer.email) || ''}
                    margin="normal" />
                </div>
                <div style={{ display: 'flex', flexWrap: 'wrap', }}>
                  <TextField
                    InputLabelProps={{ shrink: true, }}
                    className={`${classes.textField} ${classes.marginRight}`}
                    disabled
                    label="Visit Count"
                    value={(this.props.customer && this.state.visitCount) || 0}
                    margin="normal" />
                  <TextField
                    InputLabelProps={{ shrink: true, }}
                    className={`${classes.textField} ${classes.marginRight}`}
                    disabled
                    label="Last Visit On"
                    value={(this.state.lastVisit && moment(this.state.lastVisit).format('ll')) || ''}
                    margin="normal" />
                </div>
              </div>
              : null}

            <br />

            {stepContent}
          </div>

        </DialogContent>

        <DialogActions>
          <Button onClick={this.handleRequestClose}>
            CLOSE
          </Button>
          {backAction}
          {stepAction}
        </DialogActions>

      </Dialog>
    );
  }
}

CheckOutDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  deskTransaction: PropTypes.object,
  passes: PropTypes.array.isRequired,
  priceRule: PropTypes.array.isRequired,
  customer: PropTypes.object,
  userPassRecord: PropTypes.object,
  branchId: PropTypes.string,
};

export default withStyles(styles)(CheckOutDialog);
